export class GoogleDocsException extends Error {}

export class GoogleSheetsException extends Error {}

export class GoogleSlidesException extends Error {}

export class GoogleDriveException extends Error {}
